

















































































































































































import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';
import { queryStockoutOrder, queryStockoutOrderSku } from '../../utils/api';
import fuzzySearch from './common/fuzzySearch.vue';
import tableEmpty from '@/components/empty/tableEmpty.vue';

interface searchItem {
  value: string;
  code: string;
}
@Component({ components: { fuzzySearch, tableEmpty } })
export default class wantList extends Vue {
  loading = false;
  currentPage = 1;
  page = 10;
  totalElements = 0;
  // 缺货编号
  stockoutOrderId = '';
  //订单编号
  orderId = '';
  //详情数据 抽屉
  detailed: object = {};
  // sku 列表
  skuSendNumList: any[] = [];
  dataList: any = [];
  resetData: any = {
    consigneeName: '',
    orderId: '',
    stockoutOrderId: '',
  };
  data = {
    pageNum: 0,
    pageSize: this.page,
    stockoutOrderId: '',
    consigneeName: '',
    orderId: '',
    partnerId: '',
  };
  drawer = false;
  size = '800px';
  searchItem: searchItem = {
    value: '',
    code: '',
  };
  mounted() {
    this.getDataList(this.data);
  }
  // 收集模糊搜索商家名称
  fuzzySearchValue(item) {
    this.searchItem = item;
    this.data.partnerId = item.code;
  }
  //获取数据
  async getDataList(data) {
    try {
      this.loading = true;
      this.currentPage = data.pageNum + 1;
      const result = await queryStockoutOrder(data);
      if (result) {
        this.loading = false;
      }
      // console.log('result---', result);
      this.dataList = result['content'];
      this.totalElements = result['totalElements'];
    } catch (error) {
      this.$message.error(error);
      this.loading = false;
    }
  }
  //分页
  async handleCurrentChange(val) {
    try {
      this.data.pageNum = val - 1;
      await this.getDataList(this.data);
    } catch (error) {}
  }
  //跳转缺货单详情
  handleClick1(row) {
    console.log('row', row);
    this.drawer = true;
    this.stockoutOrderId = row.stockoutOrderId.toString();
    console.log(this.stockoutOrderId);
    const params = {
      stockoutOrderId: this.stockoutOrderId,
    };

    queryStockoutOrderSku(params)
      .then((res) => {
        if (res) {
          this.detailed = res;
        }
        // this.skuSendNumList = (this as any).detailed.orderSkus.map((item: any) => {
        //   return item;
        // });
      })
      .catch((error) => {
        this.$message.error(error);
      });
  }
  handleClick2() {
    this.drawer = false;
  }
  //查询
  search() {
    this.data.stockoutOrderId = this.data.stockoutOrderId.trim();
    this.data.consigneeName = this.data.consigneeName.trim();
    this.data.orderId = this.data.orderId.trim();
    this.data.pageNum = 0;
    this.currentPage = this.data.pageNum + 1;
    this.getDataList(this.data);
  }
  //清空
  reset() {
    this.data = {
      pageNum: 0,
      pageSize: this.page,
      stockoutOrderId: '',
      consigneeName: '',
      orderId: '',
      partnerId: '',
    };
    // 重置模糊搜索输入框
    Object.assign((this as any).$data.searchItem, (this as any).$options.data['call'](this).searchItem);
    this.getDataList(this.data);
  }
}
